import React from "react";
import "./auth.scss";
import { Link, useNavigate } from "react-router-dom";
import RegisterForm from "./forms/RegisterForm";
import { Gift, Globe2, ShieldCheck } from "lucide-react";
import AuthRecommendedDeal from "./AuthRecommendedDeal";


const Register = () => {
  const navigate = useNavigate();


  return (
    <div className="auth-section auth-section--register">
      <div className="left">
        <div className="auth-hero-panel">
          <Link to="/" className="auth-brand">
            <img src="/images/Android.png" alt="Teleport Now Logo" />
            <span>Teleport Now</span>
          </Link>

          <div className="auth-hero-copy">
            <p className="auth-eyebrow">Start travelling smarter</p>
            <h1>Create one account for eSIMs, deals, and trip essentials.</h1>
            <p>
              Join Teleport Now to unlock travel data, booking tools, referral
              rewards, and app-exclusive offers.
            </p>
          </div>

          <div className="auth-benefit-grid">
            <div>
              <Gift size={20} />
              <span>$3 USD referral credit</span>
            </div>
            <div>
              <Globe2 size={20} />
              <span>Global data coverage</span>
            </div>
            <div>
              <ShieldCheck size={20} />
              <span>Secure checkout</span>
            </div>
          </div>

          <AuthRecommendedDeal />
        </div>
      </div>

      <div className="right">
        <RegisterForm  
          goToOtpVerify={(userId, email, password) => {navigate("/verify", { state: {userId, email, password }});}} 
          onSocialLoginSuccess={() => {navigate("/");}}
        />
      </div>
    </div>
  );
};

export default Register;
